import { NgModule } from "@angular/core";
import { CoreModule } from "../../../core/core.module";
import { MapBoxComponent } from "./map-box.component";
import { MapBoxService } from "./map-box.service";

@NgModule({
  declarations: [MapBoxComponent],
  imports: [CoreModule],
  exports: [MapBoxComponent],
  providers: [MapBoxService],
})
export class MapBoxModule {}
